import { fileFormToUpdate } from '@/_containers';
import { statusToStr } from '@/_schemas/status-input';

import type { CompetitorFormSchema, CompetitorUpdateSchema } from '../schemas';

export function competitorFormToUpdate({
  status,
  logo,
  addresses,
  primary_contact,
  associated_clients,
  phone_numbers,
  ceo_contact,
  current_web_clients,
  ...rest
}: CompetitorFormSchema): CompetitorUpdateSchema {
  return {
    ...rest,
    status: statusToStr(status),
    logo: fileFormToUpdate(logo),
    addresses: addresses?.map((item) => item.id) ?? [],
    primary_contact: primary_contact?.map((item) => item.id) ?? [],
    associated_clients: associated_clients?.map((item) => item.id) ?? [],
    phone_numbers: phone_numbers?.map((item) => item.id) ?? [],
    ceo_contact: ceo_contact?.map((item) => item.id) ?? [],
    current_web_clients: current_web_clients?.map((item) => item.id) ?? [],
  } as CompetitorUpdateSchema;
}
